import type { NavigatorSignals, ScreenSignals } from "../types";
import { safe } from "../utils/safe";

export function collectNavigator(): NavigatorSignals {
  const n = navigator as Navigator & { deviceMemory?: number };
  return {
    platform: safe(() => n.platform || null, null),
    vendor: safe(() => n.vendor || null, null),
    language: safe(() => n.language || null, null),
    languages: safe(() => [...(n.languages ?? [])], []),
    hardwareConcurrency: safe(() => n.hardwareConcurrency ?? null, null),
    deviceMemory: safe(() => n.deviceMemory ?? null, null),
    maxTouchPoints: safe(() => n.maxTouchPoints ?? null, null),
    webdriver: safe(() => n.webdriver === true, false),
  };
}

export function collectScreen(): ScreenSignals {
  return {
    width: safe(() => screen.width, 0),
    height: safe(() => screen.height, 0),
    availWidth: safe(() => screen.availWidth, 0),
    availHeight: safe(() => screen.availHeight, 0),
    colorDepth: safe(() => screen.colorDepth, 0),
    pixelRatio: safe(() => window.devicePixelRatio, 1),
    frame: safe<[number, number, number, number]>(() => {
      // availTop / availLeft are non-standard; present in Chromium, absent in the DOM lib types.
      const s = screen as Screen & { availTop?: number; availLeft?: number };
      const availTop = s.availTop ?? 0;
      const availLeft = s.availLeft ?? 0;
      return [
        availTop,
        (s.width ?? 0) - (s.availWidth ?? 0) - availLeft,
        (s.height ?? 0) - (s.availHeight ?? 0) - availTop,
        availLeft,
      ];
    }, [0, 0, 0, 0]),
  };
}
